import React from 'react';
import { Building, Copy, Mail } from 'lucide-react';
import Card from '../components/ui/Card';
import CardContent from '../components/ui/CardContent';
import Layout from '../components/Layout';

const RequisitesPage = () => {
  const handleEmailClick = () => {
    window.location.href = `mailto:${companyDetails.email}`;
  };

  const companyDetails = {
    name: "ИП Платов Олег Сергеевич",
    inn: "772840374009",
    ogrnip: "324774600271475",
    email: "Oleg.platov.04@mail.ru"
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center space-x-3 mb-8">
          <Building className="w-8 h-8 text-blue-600" />
          <h1 className="text-3xl font-bold">Реквизиты</h1>
        </div>

        <Card className="mb-8">
          <CardContent className="p-6">
            <div className="space-y-4">
              {Object.entries(companyDetails).map(([key, value]) => (
                <div key={key} className="flex justify-between items-center p-2 hover:bg-gray-50 rounded">
                  <div>
                    <div className="text-sm text-gray-500 capitalize">
                      {key === 'ogrnip' ? 'ОГРНИП' : 
                       key === 'inn' ? 'ИНН' : 
                       key === 'email' ? 'Email' : 
                       key}
                    </div>
                    <div className="font-medium">
                      {key === 'email' ? (
                        <button
                          onClick={handleEmailClick}
                          className="flex items-center space-x-2 text-blue-600 hover:text-blue-700"
                        >
                          <Mail className="w-4 h-4" />
                          <span>{value}</span>
                        </button>
                      ) : (
                        value
                      )}
                    </div>
                  </div>
                  <button
                    onClick={() => copyToClipboard(value)}
                    className="p-2 hover:bg-gray-100 rounded-full"
                    title="Копировать"
                  >
                    <Copy className="w-4 h-4 text-gray-500" />
                  </button>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <div className="bg-blue-50 p-4 rounded-lg">
          <p className="text-sm text-gray-600">
            Для получения дополнительной информации, пожалуйста, свяжитесь с нами по указанному email.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default RequisitesPage;